// extracted by mini-css-extract-plugin
export var avatar = "styles-module--avatar--25c0b";
export var commentLink = "styles-module--commentLink--1d40c";
export var item = "styles-module--item--6aa6c styles-module--segment--6c3eb";
export var linkIcons = "styles-module--linkIcons--72f60 styles-module--segment--6c3eb";
export var list = "styles-module--list--707d0";
export var segment = "styles-module--segment--6c3eb";
export var wrapper = "styles-module--wrapper--b4f39";